<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Sucursal Aseguradora
            <v-spacer></v-spacer>
            <v-dialog v-model="dialogForm" persistent :max-width="tamModal" :fullscreen="$root.isTouch" :scrollable="$root.isTouch == false">
                <sucursalAseguradoraModal :seleccionado="seleccionado" :tituloFormulario="tituloFormulario" :listaGeneral="listaGeneral" :listaCanton="listaCantonFiltro"></sucursalAseguradoraModal>
            </v-dialog>
            <v-btn rounded class="text-right" dark color="primary" @click="dialogForm = true">Nuevo</v-btn>

        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-md>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-autocomplete label="Aseguradora *" color="textbox" v-model="aseguradoraFiltrado"
                            :items="listaGeneral.aseguradora" item-text="aseguradora" item-value="idAseguradora"
                            @change="listar" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-autocomplete label="Provincia *" color="textbox" v-model="provinciaFiltrado"
                            :items="listaGeneral.provincia" item-text="text" item-value="value"
                            @change="listarCanton('filtro'); cantonFiltrado=null" outlined dense />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-autocomplete label="Cantón *" color="textbox" v-model="cantonFiltrado"
                            :items="listaGeneral.canton" item-text="canton" item-value="idCanton" @change="listar"
                            outlined dense />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-autocomplete label="Estado" color="textbox" v-model="estadoFiltrado" :items="listaGeneral.estado"
                            item-text="nombre_estado" item-value="id_estado" @change="listar" outlined dense />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6"/>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="buscar" prepend-inner-icon="search"
                            clearable />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col xs12>
                        <v-data-table :headers="listaGeneral.cabecera" :items="listaGeneral.detalle" :search="buscar"
                            class="elevation-1">
                            <template v-slot:item.accion="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="editarItem(item)">
                                    <v-icon small>edit</v-icon>
                                </v-btn>
                            </template>
                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-text="buscar"></span>" no arrojó resultados.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        name: "SucursaAseguradoralView",
        created() {
            this.cargaGeneral();
        },
        watch: {
            listaGeneral() {
                this.aseguradoraFiltrado = this.listaGeneral.aseguradora[0].idAseguradora;
                this.listar('l');
            }
        },
        data() {
            return {
                listaGeneral: {},
                listaCantonFiltro: [],
                buscar: null,
                seleccionado: {},
                estadoFiltrado: null,
                dialogForm: false,
                maskp: 'phone',
                aseguradoraFiltrado: null,
                cantonFiltrado: null,
                provinciaFiltrado: null,
            }
        },
        computed: {
            tituloFormulario() {
                return this.seleccionado === {} ? 'Nuevo Sucursal Aseguradora' : 'Editar Sucursal Aseguradora'
            }
        },

        components: {
            sucursalAseguradoraModal:() => import('@/components/aseguradora/ModalSucursalAseguradoraComponent.vue')
        },
        provide: function () {
            return {
                insertarActualizar: this.insertarActualizar,
                listarCanton: this.listarCanton,
                cerrarFormulario: this.cerrarFormulario
            }
        },

        methods: {
            cargaGeneral() {
                axios.post(`${BASE_URI}administrador/sucursalAseguradora/cargaGeneral`, {
                        opcion: 'L'
                    })
                    .then((respuesta) => {
                        if (respuesta.status == '200' && respuesta.statusText == 'OK') {
                            if (!respuesta.existeError) {
                                this.listaGeneral = respuesta.data.data;
                                this.listaGeneral.cabecera.push({
                                    text: "Accion",
                                    value: 'accion'
                                });
                            } else mensajesAlerta(respuesta.mensaje, 'W');
                        }
                    })
                    .catch(function (er) {
                        mensajesAlerta("Ocurrio un error", "E");
                    });
            },
            editarItem(item) {
                this.seleccionado = Object.assign({}, item);
                this.listarCanton();
                this.dialogForm = true
            },
            cerrarFormulario() {
                this.dialogForm = false
                this.seleccionado = {}
                this.listaCantonFiltro = []
            },
            listar(e) {
                if (!_.isUndefined(e)) {
                    const canton = this.cantonFiltrado
                    const aseguradora = this.aseguradoraFiltrado
                    const estado = this.estadoFiltrado
                    const provincia = this.provinciaFiltrado
                    this.detalle = [];
                    axios.post(`${BASE_URI}administrador/sucursalAseguradora/listar`, {
                            opcion: 'L',
                            idCanton: canton,
                            idProvincia: provincia,
                            idAseguradora: aseguradora,
                            idEstado: estado,
                        })
                        .then((respuesta) => {
                            if (respuesta.status == '200' && respuesta.statusText == 'OK' && respuesta.data
                                .existeError != null) {
                                if (!respuesta.existeError) {
                                    this.listaGeneral.detalle = respuesta.data.data;
                                } else mensajesAlerta(respuesta.mensaje, 'W');
                            } else mensajesAlerta(mensajeEstandar.errorPeticion, "E")
                        })
                        .catch(function (er) {
                            mensajesAlerta(mensajeEstandar.errorInesperado, "E");
                        });
                }
            },
            listarCanton(select) {
                var provincia = "0";
                if (select == "filtro") provincia = this.provinciaFiltrado;
                else provincia = this.seleccionado.idProvincia;
                if (!_.isUndefined(provincia)) {

                    axios.post(`${BASE_URI}administrador/canton/listar`, {
                            opcion: 'L',
                            idProvincia: provincia,
                        })
                        .then((respuesta) => {
                            if (respuesta.status == '200' && respuesta.statusText == 'OK' && respuesta.data
                                .existeError != null) {
                                if (!respuesta.existeError) {
                                    if (select == "filtro") this.listaGeneral.canton = respuesta.data.data;
                                    else this.listaCantonFiltro = respuesta.data.data;
                                    this.listar('l');
                                } else mensajesAlerta(respuesta.mensaje, 'W');
                            } else mensajesAlerta(mensajeEstandar.errorPeticion, "E")
                        })
                        .catch(function (er) {
                            mensajesAlerta(mensajeEstandar.errorInesperado, "E")
                        });
                }
            },
            insertarActualizar(_opcion) {
                axios.post(`${BASE_URI}administrador/sucursalAseguradora/insertarActualizar`, {
                        opcion: _opcion,
                        sucursal: this.seleccionado
                    })
                    .then((respuesta) => {
                        if (respuesta.status == '200' && respuesta.statusText == 'OK' && respuesta.data
                            .existeError != null) {
                            if (!respuesta.existeError) {
                                this.listar('l');
                                mensajeAlertaTiempo(respuesta.data.mensaje, "S");
                            } else mensajesAlerta(respuesta.mensaje, 'E');
                        } else mensajesAlerta(mensajeEstandar.errorPeticion, "E")
                    })
                    .catch(function (er) {
                        mensajesAlerta(mensajeEstandar.errorInesperado, "E")
                    });
            }
        }
    }
</script>